<template>
  <div class="space">
    <v-text-field
      :label="label"
      placeholder="********"
      autocomplete="on"
      :rules="passwordRule"
      v-model="password"
      :type="showPassword ? 'text' : 'password'"
      :append-icon="showPassword ? 'visibility' : 'visibility_off'"
      @click:append="showPassword = !showPassword"
      @input="checkPassword"
      required
      outlined
      dense
      :disabled="disabled"
      hide-details
    ></v-text-field>
    <v-progress-linear
      class="progress"
      :value="progress"
      height="3"
    ></v-progress-linear>
    <div class="mt-1 mb-2">
      <span class="a-text-sm">Deve conter ao menos:</span>
      <div
        v-for="(val, key) in msgError"
        :key="key"
        class="d-flex row ml-0 mt-0 mb-1 align-center"
      >
        <v-expand-x-transition>
          <v-icon
            v-show="password"
            small
            :class="[password ? val.color : '', 'a-text-sm mr-1']"
            >{{val.color === "primary--text" && password ? "done" : "close"}}</v-icon>
        </v-expand-x-transition>
        <span :class="[password ? val.color : '', 'a-text-sm', 'lineheight']">{{val.msg}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { passwordStrength } from "check-password-strength";

export default {
  data() {
    return {
      password: undefined,
      showPassword: false,
      invalidPassword: false,
      passwordRule: [
        (v) => (!!v && !this.invalidPassword) || "Campo incompleto.",
      ],
      msgError: {
        lowercase: {
          msg: "1 caractere minúsculo.",
          color: "error--text",
        },
        uppercase: {
          msg: "1 caractere maiúsculo.",
          color: "error--text",
        },
        number: { msg: "1 número.", color: "error--text" },
        symbol: { msg: "1 caractere especial.", color: "error--text" },
        characters: { msg: "8 caracteres.", color: "error--text" },
      },
      check: undefined,
    };
  },
  props: {
    label: {
      type: String,
      default: "Senha*",
    },
    reset: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  mounted() {
    this.check = passwordStrength(this.password);
  },
  computed: {
    progress() {
      const max = 4;
      let val =
        this.check && this.check.contains ? this.check.contains.length : 0;
      return (100 * val) / max;
    },
  },
  watch: {
    reset() {
      this.resetFields();
    },
  },
  methods: {
    checkPassword() {
      this.checkRequirements();
      if (!this.invalidPassword) this.$emit("input", this.password);
      else this.$emit("input", undefined);
    },
    checkRequirements() {
      this.check = passwordStrength(this.password);
      this.checkPasswordLength()
      if (this.check && this.check.contains) {
        for (const key in this.msgError) {
          let elem = this.msgError[key];
          if (this.check.contains.find((e) => e == key))
            elem.color = "primary--text";
          else elem.color = "error--text";
        }
        if (this.check.contains.length == 5)
          this.invalidPassword = false;
        else this.invalidPassword = true;
      } else {
        this.invalidPassword = false;
      }
    },
    resetFields() {
      for (const key in this.msgError) {
        let elem = this.msgError[key];
        elem.color = "primary--text";
      }
      this.invalidPassword = false;
      this.password = undefined;
      this.check.contains = [];
    },
    checkPasswordLength() {
      if (this.password && this.password.length >= 8) {
        this.check.contains.push('characters')
      }
    },
  },
};
</script>

<style scoped>
.space {
  position: relative;
}
.progress {
  position: absolute;
  margin: 2px;
  top: 38px;
}
.lineheight {
  line-height: 16px;
}
</style>
